import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import { getBranchList, getCatalogList } from "../setting/services/settingApi";
import api from "../../api/api";
import { saveAs } from "file-saver";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { REPORT_CONFIG } from "./config";
import { MobileDatePicker } from "@mui/x-date-pickers";
import InputSearch from "../../component/InputSearch";
const BrowserInput = function BrowserInput(props) {
  const {
    inputProps,
    InputProps,
    ownerState,
    value,
    inputRef,
    error,
    ...other
  } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
};
export default function LotMovementReport() {
  const [branchs, setBranchs] = useState([]);
  const [Catalog, setCatalog] = useState([]);
  const [CatalogNo, setCatalogNo] = useState("");
  const [BranchNo, setBranchsNo] = useState("");
  const [Lot, setLot] = useState("");
  const [s, setS] = useState("");
  const [cis, setCis] = useState("");
  const [y, setY] = useState();

  const [reports, setReports] = useState([]);
  const [sumValue, setSumValue] = useState();
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);

  const { profile } = useSelector((state) => state.profile);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const breedClass = [
    {
      value: "หลัก",
    },
    {
      value: "ขยาย",
    },
    {
      value: "จำหน่าย",
    },
  ];

  const seasons = [
    {
      value: "แล้ง",
    },
    {
      value: "ฝน",
    },
  ];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    getBranchList(null, setBranchs);
    getCatalogList(null, setCatalog);
    LoadReport();
  }, []);
  function calculateSum() {
    const sumValue = { NetPrice: 0 };

    for (const row of reports) {
      sumValue.NetPrice += +row.NetPrice;
    }

    setSumValue(sumValue);
  }
  useEffect(() => {
    calculateSum();
  }, [reports]);

  async function getLotMovementReport(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.lotMovementReport.url}/${mode}`;

    let params = {};

    if (body.branchNo !== "-")
      params = {
        ...params,
        BranchNo: body.branchNo || profile?.BranchNo?.BranchNo,
      };
    if (body.c !== "-") params = { ...params, CatalogNo: body.c };
    if (body.lot !== "-") params = { ...params, Lot: body.lot };
    if (body.s !== "-") params = { ...params, s: body.s };
    if (body.cis !== "-") params = { ...params, cis: body.cis };
    if (body.y !== "-") params = { ...params, y: body.y };
    if (format !== "-") params = { ...params, format: format };

    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url, {
        params: params,
        responseType: "arraybuffer",
      });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "ข้อมูลเมล็ดพันธุ์ข้าวตามเลขที่ล็อต");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "ข้อมูลเมล็ดพันธุ์ข้าวตามเลขที่ล็อต");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url, { params: params });
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }
  async function LoadReport() {
    const body = {
      branchNo: BranchNo || undefined,
      lot: Lot || undefined,
      c: CatalogNo || undefined,
      s: s || undefined,
      cis: cis || undefined,
      y: y || undefined,
    };
    getLotMovementReport(body, "data");
  }
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  {profile?.BranchNo?.BranchNo === "00" && (
                    <div class="col-12">
                      <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={BranchNo || "-"}
                            onChange={(e) => setBranchsNo(e.target.value)}
                            disableUnderline
                          >
                            <MenuItem value="-">-</MenuItem>
                            {branchs?.map((x) => (
                              <MenuItem value={x?.BranchNo}>
                                {x?.BranchName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  )}

                  <div class="col-12">
                    <label class="labelInput">พันธุ์ข้าว</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={CatalogNo || "-"}
                          onChange={(e) => setCatalogNo(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {Catalog?.map((x) => (
                            <MenuItem value={x?.CatalogNo}>
                              {x?.CatalogName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>

                  <div class="col-12">
                    <label class="labelInput">ชั้นพันธุ์</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={cis || "-"}
                          onChange={(e) => setCis(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {breedClass?.map((x) => (
                            <MenuItem value={x.value}>{x.value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">ฤดู</label>

                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={s || "-"}
                          onChange={(e) => setS(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {seasons?.map((x) => (
                            <MenuItem value={x.value}>{x.value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">ปี</label>

                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        value={y}
                        onChange={(e) => setY(e.target.value)}
                        variant="standard"
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                        }}
                        onKeyPress={(even) => {
                          if (!/[0-9.]/.test(even.key)) {
                            even.preventDefault();
                          }
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">เลขที่ล็อต</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        variant="standard"
                        value={Lot}
                        onChange={(e) => setLot(e.target.value)}
                        fullWidth
                        placeholder={"ค้นหา เลขที่ล็อต"}
                        InputProps={{
                          disableUnderline: true,
                          //   startAdornment: (
                          //     <Box sx={{ marginRight: "10px" }}>
                          //       <FontAwesomeIcon icon={faSearch} />
                          //     </Box>
                          //   ),
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>ข้อมูลเมล็ดพันธุ์ข้าวตามเลขที่ล็อต</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 100,
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          const body = {
                            branchNo: BranchNo || undefined,
                            lot: Lot || undefined,
                            c: CatalogNo || undefined,
                            s: s || undefined,
                            cis: cis || undefined,
                            y: y || undefined,
                          };
                          // setFormat('')
                          getLotMovementReport(body, "file");

                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          const body = {
                            branchNo: BranchNo || undefined,
                            lot: Lot || undefined,

                            c: CatalogNo || undefined,
                            s: s || undefined,
                            cis: cis || undefined,
                            y: y || undefined,
                          };
                          // setFormat('pdf')
                          getLotMovementReport(body, "file", "pdf");

                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col">ประเภทรายการ</th>
                            <th scope="col">เลขที่เอกสาร/เลข DOI</th>
                            <th scope="col">วันที่ทำรายการ</th>
                            <th scope="col">ประเภทลูกค้า</th>
                            <th scope="col">ประเภทการขาย</th>
                            <th scope="col">ประเภทการจ่าย</th>
                            <th scope="col">ส่วนลด %</th>
                            <th scope="col">ปริมาณ (กก.)</th>
                            <th scope="col">ยอดขายสุทธิ (บาท)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, i) => (
                            <tr class="cp">
                              <td class="text-center">{report?.ActionType}</td>
                              <td class="text-center">{report?.DocumentId}</td>
                              <td class="text-center">
                                {dayjs(report?.DocDate).format("DD/MM/YYYY")}
                              </td>
                              <td class="text-center">
                                {report?.CustomerTypeName || "-"}
                              </td>
                              <td class="text-center">
                                {report?.SaleType || "-"}
                              </td>
                              <td class="text-center">
                                {report?.PaymentType || "-"}
                              </td>
                              <td class="text-center">
                                {report?.DiscountPercent || "0"}
                              </td>
                              <td class="text-center">
                                {report?.Qty
                                  ? report?.Qty.toLocaleString()
                                  : "0"}
                              </td>
                              <td class="text-center">
                                {report?.NetPrice
                                  ? parseFloat(report?.NetPrice)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                  : 0}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <thead class="sticky-tfooter">
                          <tr>
                            <th scope="col" colspan="8">
                              รวม
                            </th>
                            <th scope="col">
                              {sumValue?.NetPrice.toLocaleString()}
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
